/* 
Object:         NodeSearch
Description:    Logic and events for node search
Used in:        NodeSearch
*/

import * as navigation from "../navigation";
import * as grid       from "../grid";

/*
* Initialize.
*/
export function initialize(): void {
    $("#NodeSearchButtonLoader").hide();

    $("#SearchText").keyup(function (event) {
        if (event.keyCode == 13) {
            searchAction();
        }
    });
    grid.loadGridOptions("SearchResultNodes");
}

/*
* node search action (submit)
*/
export function searchAction(): void {
    $("#NodeSearchButtonLoader").show();
    $("#SearchResultNodes").data("kendoGrid").pager.dataSource.page(1);
    $("#SearchResultNodes").data("kendoGrid").dataSource.read();
}

/*
* node search action (submit)
*/
export function getAdditionalData(): { text: string } {

    return {
        text: $("#SearchText").val().toString()
    };
}

/*
 * node search action (submit)
 */
export function jumpNode(e: kendo.ui.GridEvent & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get Data Item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as { NodeID: number };

    // Jump Node
    navigation.jumpNode(dataItem.NodeID);
}

/*
* node search action (submit)
*/
export function onDataBound(event: kendo.ui.GridDataBoundEvent): void {
    $("#NodeSearchButtonLoader").hide();
    grid.saveGridOptions(event);
}
